import { render, staticRenderFns } from "./SocialAttendanceTypeCreate.vue?vue&type=template&id=55d087d0&"
import script from "./SocialAttendanceTypeCreate.js?vue&type=script&lang=js&"
export * from "./SocialAttendanceTypeCreate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports